export default "__VITE_ASSET__CavmSqt7__"